import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Footer from '../../../common/footerNew';
import Header from '../../../common/header';

const GlobalWrapper = styled.div`
  min-height: 100vh;
`;

const Layout = ({ location, children }) => {
  const header = (
    <Header location={location} appType="GATSBY" LinkComponent={Link} />
  );

  return (
    <>
      <GlobalWrapper className="global-wrapper">
        <header className="global-header">{header}</header>
        <main>{children}</main>
      </GlobalWrapper>
      <Footer location={location} appType="GATSBY" />
    </>
  );
};

export default Layout;
